import { render, staticRenderFns } from "./placeofservice.vue?vue&type=template&id=788d27d6&"
import script from "./placeofservice.vue?vue&type=script&lang=js&"
export * from "./placeofservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports